import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Chip, FormControl, FormHelperText, IconButton, Menu, MenuItem, Select, Stack, Tooltip, Typography, useMediaQuery } from "@mui/material"
import Grid from "@mui/material/Grid2"
import * as React from "react"
import { SERVICE_ORDER_SERVICE_COLOR_MAP, SERVICE_ORDER_SERVICE_FRIENDLY_NAMES, SERVICE_ORDER_CUSTOMER_APPROVAL_FRIENDLY_NAMES, LONG_DATE_FORMAT, AXIOS_API_INSTANCE, SERVICE_ORDER_CUSTOMER_APPROVAL_COLOR_MAP, get_service_order_part_color } from "../../Constants"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RemoveShoppingCartIcon from '@mui/icons-material/RemoveShoppingCart';
import AddCircleSharpIcon from '@mui/icons-material/AddCircleSharp';
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import { formatDuration, moneyFormat, widthChangeEvent } from "../../Utils"
import { DataGrid, gridClasses } from "@mui/x-data-grid"
import dayjs from "dayjs"
import RemoveServiceOrderServiceModal from "./Modals/RemoveServiceOrderServiceModal"
import ChangeServiceOrderServiceStatusModal from "./Modals/ChangeServiceOrderServiceStatusModal";
import AddPartModal from "./Modals/AddPartModal";
import UserAvatar from "../UserAvatar";
import { send_authorized_request } from "../../Constants/cognito";
import { useSnackbar } from "notistack";
import InstallAllPartsModal from "./Modals/InstallAllPartsModal";
import ChangeCustomerApprovalStatusModal from "./Modals/ChangeCustomerApprovalStatusModal";
import InputModal from "../modals/InputModal";
import { useUsers, findUser } from "../ReactQuery/QueryUsers";
import ServiceOrderServiceInfoModal from "./Modals/ServiceOrderServiceInfoModal";
import { useTrackedDarkMode, useTrackedUser } from "../UserState";
import { useTheme } from "@emotion/react";
import ServiceOrderPartStatusDropdown from "./ServiceOrderPartStatusDropdown";

const service_statuses = Object.keys(SERVICE_ORDER_SERVICE_FRIENDLY_NAMES)

export default function ServiceOrderService(
    {
        serviceOrder,
        service,
        setServiceOrder,
        setMadeUpdate,
        setServiceOrderSavingStep,
        warrantiedServices,
        warrantiedParts
    }
) {
    const theme = useTheme()
    const { enqueueSnackbar } = useSnackbar();
    const { data: users, } = useUsers();
    const [my_user,] = useTrackedUser();
    const [darkMode,] = useTrackedDarkMode();
    const [removeServiceModalOpen, setRemoveServiceModalOpen] = React.useState(false);
    const [changeServiceStatusModalOpen, setChangeServiceStatusModalOpen] = React.useState(false);
    const [addPartModalOpen, setAddPartModalOpen] = React.useState(false);
    const [installAllPartsModalOpen, setInstallAllPartsModalOpen] = React.useState(false);
    const [editPartModalOpen, setEditPartModalOpen] = React.useState(false);
    const [selectedPart, setSelectedPart] = React.useState({});
    const [serviceOrderServiceOptionsAnchorEl, setServiceOrderServiceOptionsAnchorEl] = React.useState(null)
    const [changeCustomerApprovalStatusModalOpen, setChangeCustomerApprovalStatusModalOpen] = React.useState(false);
    const [windowInnerWidth, setWindowInnerWidth] = React.useState(window.innerWidth)
    const [changeNameModal, setChangeNameModal] = React.useState({
        open: false,
        label: 'New Service Name (Customer Visible)',
        callback: (results, value) => {
            if (results) {
                setServiceOrderSavingStep(1)
                const body = {
                    serviceorderservice_id: service.id,
                    name: value
                }
                send_authorized_request(() => AXIOS_API_INSTANCE.post(`serviceorders/${serviceOrder.id}/update_service_name`, body).then((serviceOrder) => {
                    setServiceOrder(serviceOrder.data.data)
                    setMadeUpdate(true)
                    setServiceOrderSavingStep(0)
                }).catch((error) => {
                    console.log(error);
                    enqueueSnackbar(`Failed to update service name: ${error.response?.data?.message ?? "Unknown Error Occurred"}`, { variant: 'error' })
                    setServiceOrderSavingStep(0)
                }))
            }
            setChangeNameModal({ ...changeNameModal, open: false })
        },
        title: 'Change Service Name',
        defaultInput: service.name
    });
    const [serviceOrderServiceSummaryNotesModal, setServiceOrderServiceSummaryNotesModal] = React.useState({
        open: false,
        label: 'Service Summary Notes (Customer Visible)',
        callback: (results, value) => {
            setServiceOrderServiceSummaryNotesModal({ ...serviceOrderServiceSummaryNotesModal, open: false })
            if (results) {
                setServiceOrderSavingStep(1)
                const body = {
                    serviceorderservice_id: service.id,
                    summary_notes: value
                }
                send_authorized_request(() => AXIOS_API_INSTANCE.post(`serviceorders/${serviceOrder.id}/update_service_summary_notes`, body).then((serviceOrder) => {
                    enqueueSnackbar('Successfully updated summary notes', { variant: 'success' })
                    setServiceOrder(serviceOrder.data.data)
                    setMadeUpdate(true)
                    setServiceOrderSavingStep(0)
                }).catch((error) => {
                    console.log(error);
                    enqueueSnackbar(`Failed to update service name: ${error.response?.data?.message ?? "Unknown Error Occurred"}`, { variant: 'error' })
                    setServiceOrderSavingStep(0)
                }))
            }
        },
        title: 'Edit Summary Notes',
        defaultInput: '',
        maxWidth: 'md',
        multiline: true,
        minRows: 3
    })
    const [serviceOrderServiceInfoModalOpen, setServiceOrderServiceInfoModalOpen] = React.useState(false)
    const isLgUp = useMediaQuery(theme.breakpoints.up('lg'))



    const serviceOrderPartsColumns = [
        {
            field: "name",
            headerName: "Name",
            flex: 1,
            editable: false,
            sortable: true,
            filterable: false,
            valueFormatter: (value) => value || "",
            renderCell: (params) => {
                return (
                    <Box>
                        <span>
                            {params.value}
                            {params.row.id in warrantiedParts &&
                                <Tooltip title={`Part has warranty claim`}>
                                    <FolderSpecialIcon sx={{ height: '100%', verticalAlign: 'middle' }} />
                                </Tooltip>
                            }
                        </span>
                    </Box>
                )
            }
        },
        {
            field: "description",
            headerName: "description",
            flex: 2,
            editable: false,
            sortable: true,
            filterable: false,
            valueFormatter: (value) => value || ""
        },
        {
            field: "sku",
            headerName: "SKU",
            flex: 1,
            editable: false,
            sortable: true,
            filterable: false,
            valueFormatter: (value) => value || ""
        },
        {
            field: "quantity",
            headerName: "Qty",
            width: 75,
            editable: false,
            sortable: true,
            filterable: false,
        },
        {
            field: "cost",
            headerName: "Price",
            width: 125,
            editable: false,
            sortable: true,
            filterable: false,
            valueFormatter: (value) => `$${moneyFormat(value ?? "")}`
        },
        {
            field: "status_name",
            headerName: "Status",
            width: 175,
            editable: false,
            cellClassName: 'datagrid-no-padding',
            getOptionLabel: (value) => <Chip label={value} color={get_service_order_part_color(my_user.client.service_order_parts_statuses, value)} />,
            renderCell: (params) => <Box
                sx={{
                    width: '100%',
                    alignItems: 'center',
                    height: '100%',
                    containerType: 'normal'
                }}
            >
                {['CREATED', 'IN_PROGRESS', 'WORK_COMPLETE'].includes(serviceOrder.status_type) ?
                    <ServiceOrderPartStatusDropdown
                        service_id={service.id}
                        part={params.row}
                        setServiceOrder={setServiceOrder}
                        setServiceOrderSavingStep={setServiceOrderSavingStep}
                        updatedPartCallback={(part) => {
                            const service_index = serviceOrder.service_order_services.findIndex((x) => x.id === service.id)
                            const part_index = serviceOrder.service_order_services[service_index].service_order_parts.findIndex((x) => x.id === params.row.id)
                            serviceOrder.service_order_services[service_index].service_order_parts[part_index] = part
                            setServiceOrder({ ...serviceOrder })
                            setMadeUpdate(true)
                        }}
                    />
                    :
                    <Chip label={params.value} color={get_service_order_part_color(my_user.client.service_order_parts_statuses, params.value)} sx={{ ml: 1 }} />
                }
            </Box>
        },
        {
            field: 'action',
            headerName: 'Edit',
            type: "actions",
            width: isLgUp ? 100 : 50,
            sortable: false,
            disableClickEventBubbling: true,

            renderCell: (params) => {
                return (
                    <Stack direction="row" spacing={2} alignItems={'center'}>
                        {isLgUp ?
                            <Button variant="contained" color="warning" size="small" onClick={() => { setSelectedPart(params.row); setEditPartModalOpen(true) }} startIcon={<EditIcon />}>Edit</Button>
                            :
                            <Button variant="contained" color="warning" size="small" onClick={() => { setSelectedPart(params.row); setEditPartModalOpen(true) }} sx={{ minWidth: 0 }}><EditIcon /></Button>
                        }
                    </Stack>
                );
            },
        }
    ]
    // Remove actions column if serviceorder is in invoiced/completed/canceled status
    if (!['CREATED', 'IN_PROGRESS', 'WORK_COMPLETE'].includes(serviceOrder.status_type)) {
        serviceOrderPartsColumns.pop()
    }
    const workHistoryColumns = [
        {
            field: "start_time",
            type: "string",
            headerName: "Time",
            width: 125,
            editable: false,
            sortable: true,
            filterable: false,
            renderCell: (params) => {
                return (
                    <Grid container alignItems="center" sx={{ height: '100%' }}>
                        <Tooltip title={`${dayjs.utc(params.row.start_time).local().format(LONG_DATE_FORMAT)} - ${dayjs.utc(params.row.end_time).local().format(LONG_DATE_FORMAT)}`}>
                            <span>{dayjs.utc(params.row.start_time).local().format("MM/DD/YYYY")}</span>
                        </Tooltip>
                    </Grid>
                )
            }
        },
        {
            field: "user_id",
            headerName: "Worker",
            width: 135,
            editable: false,
            sortable: true,
            filterable: false,
            renderCell: (params) => {
                const user = findUser(users, params.row.user_id)
                return (
                    (<Grid container space={1} alignItems="center" sx={{ height: '100%' }}>
                        <Grid sx={{ pr: 1 }} size="auto">
                            <span><UserAvatar user={user} tooltip={user?.name} /></span>
                        </Grid>
                    </Grid>)
                );
            }
        },
        {
            field: "recorded_minutes",
            headerName: "Duration",
            width: 100,
            editable: false,
            sortable: false,
            filterable: false,
            valueGetter: (value, row) => row.recorded_minutes,
            valueFormatter: (value) => formatDuration(value),
            renderCell: (params) => {
                return (
                    <Grid container alignItems="center" sx={{ height: '100%' }}>
                        <span>{params.formattedValue}</span>
                    </Grid>
                );
            }
        },
        {
            field: "note",
            headerName: "Comments",
            flex: 1,
            editable: false,
            sortable: false,
            filterable: false,
            valueGetter: (value, row) => row.note,
        },
    ]

    const changeStatus = (e) => {
        setServiceOrderSavingStep(1)
        const new_status = {
            serviceorderservice_id: service.id,
            status: e.target.value
        }
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.post(`serviceorders/${service.service_order_id}/change_service_status`, new_status).then((serviceOrder) => {
                setServiceOrderSavingStep(0)
                enqueueSnackbar('Successfully changed status', { variant: 'success' })
                setServiceOrder(serviceOrder.data.data)
                setMadeUpdate(true)
            }).catch((error) => {
                setServiceOrderSavingStep(0)
                enqueueSnackbar(`Failed to change status <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
            })
        )
    }

    const closeModalFunction = (setChangeStatus) => (results) => {
        if (results) {
            setServiceOrder(results)
            setMadeUpdate(true)
        }
        setChangeStatus(false)
    }

    let pricing_situation = "Default"
    let flat_rate_pricing = service.default_flat_rate
    let hourly_rate_pricing = Math.round(service.default_hourly_rate * service.default_minutes_worked * 100 / 60) / 100
    let parts_pricing = service.service_order_parts.reduce((accumulator, item) => accumulator + Math.round(item.cost * (service.part_price_adjustment + 100) * item.quantity) / 100, 0)
    let minutes_worked = service.default_minutes_worked
    if (service.official_flat_rate !== null) {
        pricing_situation = "Invoiced"
        flat_rate_pricing = service.official_flat_rate
        minutes_worked = service.official_minutes_worked
        hourly_rate_pricing = service.official_hourly_rate * service.official_minutes_worked / 60
        parts_pricing = service.service_order_parts.reduce((accumulator, item) => accumulator + (item.actual_cost * item.quantity), 0)
    }
    else if (service.quoted_flat_rate !== null) {
        pricing_situation = "Quoted"
        flat_rate_pricing = service.quoted_flat_rate
        minutes_worked = service.quoted_minutes_worked
        hourly_rate_pricing = service.quoted_hourly_rate * service.quoted_minutes_worked / 60
        parts_pricing = service.service_order_parts.reduce((accumulator, item) => accumulator + (item.quoted_cost * item.quantity), 0)
    }
    const total_pricing = flat_rate_pricing + hourly_rate_pricing + parts_pricing

    React.useEffect(() => {
        return widthChangeEvent(setWindowInnerWidth)
    }, [])

    return (
        (<Box key={service.id} sx={{ ml: 1, pl: 1, pr: 1, pb: 1, position: 'relative', borderRadius: '15px', bgcolor: `backgroundColor.${darkMode ? 'light' : 'dark'}` }}>
            {service.status === 'PENDING' &&
                <Box sx={{ position: 'absolute', right: 8, top: 8 }}>
                    <Button onClick={() => setRemoveServiceModalOpen(true)} sx={{ color: 'red' }}>Cancel <RemoveShoppingCartIcon /></Button>
                </Box>
            }
            <Grid container>
                <Grid size="grow">
                    <h2>{service.name}
                        {service.id in warrantiedServices &&
                            <Tooltip title={`Service has warranty claim`}>
                                <FolderSpecialIcon sx={{ height: '100%', verticalAlign: 'middle' }} />
                            </Tooltip>
                        }
                        <IconButton
                            aria-label="more"
                            id="long-button"
                            aria-controls={Boolean(serviceOrderServiceOptionsAnchorEl) ? 'long-menu' : undefined}
                            aria-expanded={Boolean(serviceOrderServiceOptionsAnchorEl) ? 'true' : undefined}
                            aria-haspopup="true"
                            onClick={(e) => setServiceOrderServiceOptionsAnchorEl(e.currentTarget)}
                        >
                            <MoreVertIcon />
                        </IconButton>
                        <Menu
                            id="long-menu"
                            anchorEl={serviceOrderServiceOptionsAnchorEl}
                            open={Boolean(serviceOrderServiceOptionsAnchorEl)}
                            onClose={() => setServiceOrderServiceOptionsAnchorEl(null)}
                            slotProps={{
                                list: {
                                    'aria-labelledby': 'long-button',
                                }
                            }}
                        >
                            <MenuItem onClick={() => { setChangeNameModal({ ...changeNameModal, open: true, defaultInput: service.name }); setServiceOrderServiceOptionsAnchorEl(null) }}>
                                Edit Name
                            </MenuItem>
                            <MenuItem onClick={() => { setChangeCustomerApprovalStatusModalOpen(true); setServiceOrderServiceOptionsAnchorEl(null) }}>
                                Edit Customer Approval
                            </MenuItem>
                            <MenuItem onClick={() => { setServiceOrderServiceSummaryNotesModal({ ...serviceOrderServiceSummaryNotesModal, defaultInput: service.summary_notes, open: true }); setServiceOrderServiceOptionsAnchorEl(null) }}>
                                Edit Service Summary Notes
                            </MenuItem>
                            <MenuItem onClick={() => { setServiceOrderServiceInfoModalOpen(true); setServiceOrderServiceOptionsAnchorEl(null) }}>
                                See Info
                            </MenuItem>
                        </Menu>
                    </h2>
                </Grid>
            </Grid>
            <Grid container columns={{ sm: 7, md: 12 }} rowSpacing={1} alignItems={'flex-start'} sx={{ mb: 1 }}>
                <Grid container alignItems={'center'} rowSpacing={1} size={5}>
                    <Grid size="auto">
                        <span>Status:</span>
                    </Grid>
                    <Grid size="grow">
                        {['CREATED', 'IN_PROGRESS', 'WORK_COMPLETE'].includes(serviceOrder.status_type) ?
                            <FormControl sx={{ m: 1, mb: 0 }} size="small">
                                <Select
                                    labelId="serviceorder-service-status-label"
                                    id="serviceorder-service-status"
                                    value={service.status}
                                    onChange={changeStatus}
                                    disabled={['NOT_REQUESTED', 'APPROVAL_REQUESTED'].includes(service.customer_approved_status)}
                                    renderValue={(status) => (
                                        <Chip label={SERVICE_ORDER_SERVICE_FRIENDLY_NAMES[status]} color={SERVICE_ORDER_SERVICE_COLOR_MAP[status] || 'primary'} />
                                    )}
                                >
                                    {service_statuses.map((status) => (
                                        <MenuItem key={status} value={status}>
                                            <Chip label={SERVICE_ORDER_SERVICE_FRIENDLY_NAMES[status]} color={SERVICE_ORDER_SERVICE_COLOR_MAP[status] || 'primary'} />
                                        </MenuItem>
                                    ))}
                                </Select>
                                {['NOT_REQUESTED', 'APPROVAL_REQUESTED'].includes(service.customer_approved_status) &&
                                    <FormHelperText>No Customer Approval</FormHelperText>
                                }
                            </FormControl>
                            :
                            <Chip label={SERVICE_ORDER_SERVICE_FRIENDLY_NAMES[service.status]} color={SERVICE_ORDER_SERVICE_COLOR_MAP[service.status] || 'primary'} />
                        }
                    </Grid>
                    <Grid size={12}>
                        <span>Approval: {<Chip label={SERVICE_ORDER_CUSTOMER_APPROVAL_FRIENDLY_NAMES[service.customer_approved_status]} color={SERVICE_ORDER_CUSTOMER_APPROVAL_COLOR_MAP[service.customer_approved_status] || 'primary'} />}</span>
                    </Grid>
                </Grid>
                <Grid size={7}>
                    <h3>{pricing_situation} Pricing</h3>
                    <Grid container columnSpacing={5} rowSpacing={0}>
                        <Grid container direction="column" size="auto">
                            <Grid>
                                <span>Flat Rate Cost</span>
                            </Grid>
                            <Grid>
                                <span>Hourly Rate</span>
                            </Grid>
                            <Grid>
                                <span>Part Costs</span>
                            </Grid>
                            <Grid>
                            </Grid>
                        </Grid>
                        <Grid container direction="column" size="auto">
                            <Grid size="grow">
                            </Grid>
                            <Grid>
                                <span>{formatDuration(minutes_worked)} hrs @ ${moneyFormat((service.official_hourly_rate ?? service.quoted_hourly_rate) ?? service.default_hourly_rate)} / hr</span>
                            </Grid>
                            <Grid>
                                <span>{service.part_price_adjustment === -100 ?
                                    "$0 (INCLUDED)"
                                    :
                                    service.part_price_adjustment === 0 ?
                                        `At Cost`
                                        :
                                        `${service.part_price_adjustment > 0 ? '+' : ''}${service.part_price_adjustment}%`
                                }</span>
                            </Grid>
                            <Grid size="grow">
                                <span><b>Total</b></span>
                            </Grid>
                        </Grid>
                        <Grid container direction="column" size="auto">
                            <Grid>
                                <span>${moneyFormat(flat_rate_pricing)}</span>
                            </Grid>
                            <Grid>
                                <span>${moneyFormat(hourly_rate_pricing)}</span>
                            </Grid>
                            <Grid>
                                <span>${moneyFormat(parts_pricing)}</span>
                            </Grid>
                            <Grid>
                                <span><b>${moneyFormat(total_pricing)}</b></span>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container direction="column" spacing={1}>
                {service.service_order_parts.filter((x) => !['INSTALLED', 'DECLINED'].includes(x.status_type)).length > 1 &&
                    <Grid>
                        <Box sx={{ mt: -1 }} >
                            <Button variant="contained" color="primary" onClick={() => { setInstallAllPartsModalOpen(true) }}>Install All</Button>
                        </Box>
                    </Grid>
                }
                {service.service_order_parts.length > 0 &&
                    <Grid size="grow">
                        <DataGrid
                            key={windowInnerWidth}
                            rows={service.service_order_parts.toSorted((a, b) => dayjs.utc(a.date_created).unix() - dayjs.utc(b.date_created).unix())}
                            // rowCount={service.service_order_parts.length}
                            columns={serviceOrderPartsColumns}
                            disableRowSelectionOnClick
                            autoHeight={true}
                            hideFooter
                        />
                    </Grid>
                }
                {['CREATED', 'IN_PROGRESS', 'WORK_COMPLETE'].includes(serviceOrder.status_type) && ['PENDING', 'IN_PROGRESS'].includes(service.status) &&
                    <Grid size="grow">
                        <Button onClick={() => setAddPartModalOpen(true)} variant="outlined" color="primary" fullWidth>
                            <AddCircleSharpIcon />
                            <Box sx={{ pl: 1 }}>Add Part</Box>
                        </Button>
                    </Grid>
                }
            </Grid>
            <Accordion disableGutters defaultExpanded={false} sx={{ mt: 1 }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="service-work-history-content"
                    id="service-work-history-header"
                >
                    <Typography>Work History</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <DataGrid
                        key={windowInnerWidth}
                        rows={serviceOrder.service_order_work_history.map((item) => {
                            const entries = item.service_order_work_history_entries.filter((e) => e.service_order_service_id === service.id)
                            if (entries.length > 0) {
                                return {
                                    ...entries[0],
                                    start_time: item.start_time,
                                    end_time: item.end_time,
                                    user_id: item.user_id
                                }
                            } else {
                                return undefined
                            }
                        }).filter((x) => x !== undefined)}
                        columns={workHistoryColumns}
                        disableRowSelectionOnClick
                        autoHeight={true}
                        hideFooter
                        getRowId={(row) => row.start_time + row.end_time}
                        getRowHeight={() => 'auto'}
                        getEstimatedRowHeight={() => 135}
                        sx={{
                            [`& .${gridClasses.cell}`]: {
                                py: 1,
                            },
                        }}
                    />
                </AccordionDetails>
            </Accordion>
            <InputModal
                {...changeNameModal}
            />
            {/* Used for service order summary notes editing */}
            <InputModal
                {...serviceOrderServiceSummaryNotesModal}
            />
            <RemoveServiceOrderServiceModal
                serviceOrderService={service}
                open={removeServiceModalOpen}
                closeModal={closeModalFunction(setRemoveServiceModalOpen)}
            />
            <ChangeServiceOrderServiceStatusModal
                serviceOrderService={service}
                open={changeServiceStatusModalOpen}
                closeModal={closeModalFunction(setChangeServiceStatusModalOpen)}
            />
            <AddPartModal
                serviceOrder={serviceOrder}
                serviceOrderService={service}
                open={addPartModalOpen || editPartModalOpen}
                part={selectedPart}
                addingNewPart={addPartModalOpen}
                closeModal={addPartModalOpen ? closeModalFunction(setAddPartModalOpen) : closeModalFunction(setEditPartModalOpen)}
            />
            <InstallAllPartsModal
                serviceOrderService={service}
                open={installAllPartsModalOpen}
                closeModal={closeModalFunction(setInstallAllPartsModalOpen)}
            />
            <ChangeCustomerApprovalStatusModal
                serviceOrder={serviceOrder}
                serviceOrderService={service}
                open={changeCustomerApprovalStatusModalOpen}
                closeModal={closeModalFunction(setChangeCustomerApprovalStatusModalOpen)}
            />
            <ServiceOrderServiceInfoModal
                service={service}
                open={serviceOrderServiceInfoModalOpen}
                closeModal={() => setServiceOrderServiceInfoModalOpen(false)}
            />
        </Box >)
    );
}
